module.exports = __webpack_public_path__ + "img/report1-2.6cf7a059.jpg";